import { MDSTooltipConfig } from "@/mds/components/tooltip";
import { resolveHotkey } from "@/modules/keyboard-shortcuts/platform";
import {
  getShortcutBinding,
  ShortcutAction,
  ShortcutBindingAction,
} from "@/modules/keyboard-shortcuts/registry";

type GetShortcutTooltipConfigArgs = Omit<MDSTooltipConfig, "shortcutLabel" | "shortcutHotkey"> & {
  action: ShortcutAction | ShortcutBindingAction;
};

export const getShortcutTooltipConfig = ({
  action,
  ...config
}: GetShortcutTooltipConfigArgs): MDSTooltipConfig => {
  const binding = getShortcutBinding(action);

  if (!binding) {
    return config;
  }

  return {
    ...config,
    shortcutHotkey: resolveHotkey(binding),
  };
};
